export function modulosObjectoNormalize(row) {
	  return {
	    // id del módulo (tolerante a distintas convenciones de nombre)
	    idModulo:
	      row.idModulo ??
	      row.IdModulo ??
	      row["IdModulo"] ??
	      row["idModulo"] ??
	      0,
	    // clave / etiqueta corta que se muestra en la topbar
	    clave: row.clave ?? row.Clave ?? row["Clave"] ?? row["clave"] ?? "",
	  };
}